import { ViewModel,View } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { UnitMultiSelectorViewModel } from "../../units/unitMultiSelector";
import { IProduct } from "../iProduct";
import  { ProductEditorView } from "./productEditor-view"
import { ProductGroupSelectorViewModel } from "../../productGroup/productGroupSelector/productGroupSelector-viewModel";

export class ProductEditorViewModel extends ViewModel implements IProduct{
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);
        this._updater = updater;
        this.unitSelector = new UnitMultiSelectorViewModel(this);
        this.productGroupSelector = new ProductGroupSelectorViewModel(this);

    }
    GetDefaultView(): View <ViewModel> {
        return new ProductEditorView();
    }
    public getTypeId(): string {
        return "VM-45EF169A-3C4D-4FBC-A9B1-4DA3F7818D45"
    }

    cloneTo(product: IProduct) {
        product.id = this.id;
        product.name = this.name;
        product.code = this.code;
        product.setUnitIds(this.getUnitIds());
        product.setProductGroupId(this.productGroupSelector.selectedGroup?.id);
    }

    closePopup(result: any) {
    }

    private _updater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set unitSelector(v: UnitMultiSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitMultiSelectorViewModel { return this._unitSelector;} private _unitSelector: UnitMultiSelectorViewModel;
    public set productGroupSelector(v: ProductGroupSelectorViewModel) { this._productGroupSelector = v; } public get productGroupSelector(): ProductGroupSelectorViewModel { return this._productGroupSelector;} private _productGroupSelector: ProductGroupSelectorViewModel;

    
    setProductGroupId(id:string){
        this.productGroupSelector.selectById(id);
    }
    getProductGroupId():string{
        return this.productGroupSelector.selectedGroup?.id;
    }

    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت کالا');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('کالا با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت کالا','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام کالا مشخص نشده است.')
        }
        // if(stringIsNullOrEmpty(this.code)){
        //     result.push('نماد کالا مشخص نشده است.')
        // }
        if(this.unitSelector.selectedItems.length==0){
            result.push('هیچ واحدی مشخص نشده است.')
        }
        return result;
    }

    setUnitIds(value: string[]) {
        this.unitSelector.selectById(value);
    }
    getUnitIds(): string[] {
        return this.unitSelector.selectedItems.map(x=>x.id);
    }
    
}

export interface IServerUpdater{
    execute(product:IProduct):Promise<any>;
}


export class ProductInserter implements IServerUpdater{
    async execute(product: IProduct): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/CreateNewSimpleProduct',{
                Name:product.name,
                Code : product.code,
                Units : product.getUnitIds(),
                GroupId : product.getProductGroupId()
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Product";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class ProductUpdater implements IServerUpdater{
    async execute(product: IProduct): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/UpdateSimpleProduct',{
                Id:product.id,
                Units:product.getUnitIds(),
                Name:product.name,
                Code:product.code,
                GroupId : product.getProductGroupId()
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Product";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}


